import { Component, OnInit } from '@angular/core';
@Component({
    selector: 'app-listado-categorias',
    templateUrl: './listado-categorias.component.html',
    styleUrl: './listado-categorias.component.scss'
})
export class ListadoCategoriasComponent implements OnInit {

    public categoriaSocial = false;
    public categoriaDeporte = false;
    public categoriaCiencia = false;
    public categoriaEmpresarial = false;
    public categoriaArte = false;

    constructor() {

    }

    ngOnInit(): void {

    }

    toggleSocial() {
        this.categoriaSocial = !this.categoriaSocial;
    }

    handleSocial(event: any) {
        this.categoriaSocial = event;
    }

    toggleDeporte() {
        this.categoriaDeporte = !this.categoriaDeporte;
    }

    handleDeporte(event: any) {
        this.categoriaDeporte = event;
    }

    toggleCiencia() {
        this.categoriaCiencia = !this.categoriaCiencia;
    }

    handleCiencia(event: any) {
        this.categoriaCiencia = event;
    }

    toggleEmpresarial() {
        this.categoriaEmpresarial = !this.categoriaEmpresarial;
    }

    handleEmpresarial(event: any) {
        this.categoriaEmpresarial = event;
    }

    toggleArte() {
        this.categoriaArte = !this.categoriaArte;
    }

    handleArte(event: any) {
        this.categoriaArte = event;
    }
}